import { vmQueryAtom, type VirtualMachineLoc } from "@/modules/compute/vmQuery.ts";
import { allServicesQueryAtom, type ManagedServiceLoc } from "@/modules/services/servicesQuery.ts";
import { mergeQueries, queryThen, type QMergedResult } from "@/utils/query/mergeQueries.ts";
import { mergeMaps } from "@warrenio/utils/collections/maps";
import { atomFamily } from "jotai-family";
import { atom } from "jotai/vanilla";

const servicesByVmIdAtom = atom((get) =>
    queryThen(get(allServicesQueryAtom), (services) => {
        const result = new Map<string, ManagedServiceLoc>();

        // Flatten all VM resources from services
        for (const service of services?.values() ?? []) {
            for (const resource of service.resources) {
                if (resource.resource_type === "vm") {
                    result.set(resource.resource_id, service);
                }
            }
        }

        return result;
    }),
);

/** VM UUID -> Resource */
export const vpcVmTargetsAtom = atomFamily((location: string) =>
    atom((get): QMergedResult<Map<string, VirtualMachineLoc | ManagedServiceLoc>> => {
        const vms = get(vmQueryAtom(location));
        const services = get(servicesByVmIdAtom);
        return mergeQueries({ vms, services }, (maps) => mergeMaps(maps));
    }),
);
